<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed border-end custom-sidebar team-sidebar-shell"
  id="sidebar1"
  [visible]="sidebarVisible"
  [unfoldable]="false"
  [narrow]="sidebarUnfoldable"
  (visibleChange)="onVisibleChange($event)"
>
  <div class="team-sidebar-shell__inner d-flex flex-column h-100 min-h-0 w-100">
  <div
    class="team-sidebar-brand"
    [class.team-sidebar-brand--collapsed]="sidebarUnfoldable"
    [class.px-3]="!sidebarUnfoldable"
  >
    <a
      routerLink="/"
      class="team-sidebar-brand__link text-decoration-none d-flex align-items-center gap-2 min-w-0"
      [class.justify-content-center]="sidebarUnfoldable"
      [attr.aria-label]="'sidebar.home' | translate"
    >
      <img
        src="assets/imalogo.png"
        alt=""
        class="team-sidebar-brand__logo flex-shrink-0"
        width="28"
        height="28"
      />
      <span *ngIf="!sidebarUnfoldable" class="team-sidebar-brand__text fw-bold mb-0">IMA One</span>
    </a>
  </div>

  <div class="px-3 pt-2 mb-3 d-flex flex-column gap-2 team-sidebar-actions" *ngIf="!chatNavMode">
    <a
      *ngIf="!sidebarUnfoldable"
      class="team-nav-session--new team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start overflow-hidden text-nowrap custom-action-btn hover-effect team-sidebar-action w-100 px-3 rounded-pill"
      [class.team-sidebar-action--ghost]="!isNewDialogActive()"
      [class.team-nav-row-active]="isNewDialogActive()"
      routerLink="/home"
      [queryParams]="{ new: '1' }"
    >
      <span class="team-nav-session__inner w-100 min-w-0">
        <svg cIcon name="cilPlus" class="team-nav-session__icon" size="lg"></svg>
        <span class="team-nav-session__text">{{ 'sidebar.new_chat' | translate }}</span>
      </span>
    </a>
    <a
      *ngIf="sidebarUnfoldable"
      class="team-nav-icon-collapsed align-self-center"
      [class.is-active]="isNewDialogActive()"
      routerLink="/home"
      [queryParams]="{ new: '1' }"
      [attr.title]="'sidebar.new_chat' | translate"
      [attr.aria-label]="'sidebar.new_chat' | translate"
    >
      <svg cIcon name="cilPlus" size="lg"></svg>
    </a>
    <button
      *ngIf="chatRouteTeamCode"
      type="button"
      class="team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start overflow-hidden text-nowrap custom-action-btn hover-effect team-sidebar-action team-sidebar-action--ghost team-sidebar-action--chat ima-unread-anchor"
      [class.w-100]="!sidebarUnfoldable"
      [ngClass]="{'justify-content-center px-0 rounded-circle w-auto align-self-center': sidebarUnfoldable, 'px-3 rounded-pill': !sidebarUnfoldable}"
      [class.team-nav-row-active]="isChatMode"
      (click)="enterChatNav()"
      [attr.title]="'sidebar.chat_dm' | translate"
      [attr.aria-label]="'sidebar.chat_dm' | translate"
    >
      <span class="team-nav-session__inner w-100 min-w-0" [class.justify-content-center]="sidebarUnfoldable">
        <svg cIcon name="cilChatBubble" class="team-nav-session__icon" size="lg"></svg>
        <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text fade-in">{{ 'sidebar.chat_dm' | translate }}</span>
      </span>
      <span class="ima-unread-dot" *ngIf="hasChatUnread" [attr.aria-label]="'layout.chat.unreadMessage' | translate"></span>
    </button>
    <button
      type="button"
      class="team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start overflow-hidden text-nowrap custom-action-btn hover-effect team-sidebar-action team-sidebar-action--ghost team-sidebar-action--apps"
      [class.w-100]="!sidebarUnfoldable"
      [ngClass]="{'justify-content-center px-0 rounded-circle w-auto align-self-center': sidebarUnfoldable, 'px-3 rounded-pill': !sidebarUnfoldable}"
      (click)="openAppModal()"
      [attr.title]="'sidebar.groups_apps' | translate"
      [attr.aria-label]="'sidebar.groups_apps' | translate"
    >
      <span class="team-nav-session__inner w-100 min-w-0" [class.justify-content-center]="sidebarUnfoldable">
        <svg cIcon name="cilApps" class="team-nav-session__icon" size="lg"></svg>
        <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text fade-in">{{ 'sidebar.groups_apps' | translate }}</span>
      </span>
    </button>
  </div>

  <ng-scrollbar
    #scrollbar="ngScrollbar"
    class="overflow team-sidebar-scroll flex-grow-1 min-h-0 pb-2"
    pointerEventsMethod="scrollbar"
    visibility="hover"
  >
    <div class="px-3 w-100 min-w-0">
    <nav
      *ngIf="!chatNavMode && favoriteApps.length > 0"
      class="team-imaginus-nav mb-3"
      [class.team-imaginus-nav--collapsed]="sidebarUnfoldable"
      [attr.aria-label]="'sidebar.favorites' | translate"
    >
      <div class="team-nav-label" *ngIf="!sidebarUnfoldable">{{ 'sidebar.favorites' | translate }}</div>
      <ng-container *ngIf="!sidebarUnfoldable">
        <a
          *ngFor="let fav of favoriteApps"
          class="team-nav-pill team-nav-fav-link text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start custom-action-btn hover-effect team-sidebar-action w-100"
          [ngClass]="{'px-3 rounded-pill': true}"
          [class.team-sidebar-action--ghost]="!isFavoriteLinkActive(fav)"
          [class.team-nav-row-active]="isFavoriteLinkActive(fav)"
          (click)="navigateFavoriteLink(fav)"
          [attr.title]="favoriteLinkTitle(fav)"
        >
          <span class="team-nav-session__inner w-100 min-w-0">
            <span class="fav-scope-avatar" aria-hidden="true">
              <img
                class="fav-scope-avatar__photo"
                [src]="favoriteScopeAvatarUrl(fav)"
                (error)="onFavoriteScopeAvatarError($event, fav)"
                alt=""
              />
              <span class="fav-scope-avatar__badge">
                <svg cIcon [name]="fav.icon || 'cilApps'" size="sm"></svg>
              </span>
            </span>
            <span class="team-nav-session__text-stack min-w-0">
              <span class="team-nav-session__text text-truncate d-block">{{ fav.label }}</span>
              <span *ngIf="favoriteScopeLabel(fav) as scopeLabel" class="fav-scope-tag text-truncate d-block">{{ scopeLabel }}</span>
            </span>
            <button
              type="button"
              class="team-nav-fav-unpin"
              (click)="onUnpinFavoriteClick($event, fav)"
              [attr.aria-label]="('layout.chat.unpinFavorite' | translate:{ label: fav.label })"
              [title]="'layout.chat.unpinHint' | translate"
            >
              <svg class="team-nav-fav-unpin__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 3.1l2.86 5.79 6.39.93-4.62 4.5 1.09 6.37L12 17.69l-5.72 3 1.09-6.37L2.75 9.82l6.39-.93L12 3.1z"
                      fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>
              </svg>
            </button>
          </span>
        </a>
      </ng-container>
      <ng-container *ngIf="sidebarUnfoldable">
        <a
          *ngFor="let fav of favoriteApps"
          class="team-nav-icon-collapsed"
          [class.team-nav-row-active]="isFavoriteLinkActive(fav)"
          (click)="navigateFavoriteLink(fav)"
          (contextmenu)="onUnpinFavoriteClick($event, fav)"
          [attr.title]="favoriteLinkTitle(fav) + ('layout.chat.unpinContext' | translate)"
          [attr.aria-label]="favoriteLinkTitle(fav)"
        >
          <span class="fav-scope-avatar fav-scope-avatar--collapsed" aria-hidden="true">
            <img
              class="fav-scope-avatar__photo"
              [src]="favoriteScopeAvatarUrl(fav)"
              (error)="onFavoriteScopeAvatarError($event, fav)"
              alt=""
            />
            <span class="fav-scope-avatar__badge">
              <svg cIcon [name]="fav.icon || 'cilApps'" size="sm"></svg>
            </span>
          </span>
        </a>
      </ng-container>
    </nav>

    <nav
      *ngIf="chatNavMode"
      class="team-imaginus-nav team-chat-nav"
      [class.team-imaginus-nav--collapsed]="sidebarUnfoldable"
      [attr.aria-label]="'layout.chat.listAria' | translate"
    >
      <div class="team-chat-nav__head" *ngIf="!sidebarUnfoldable">
        <button
          type="button"
          class="team-chat-nav__back"
          (click)="exitChatNav()"
          [title]="'layout.chat.backToApps' | translate"
        >
          <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span>{{ 'layout.chat.back' | translate }}</span>
        </button>
        <span class="team-chat-nav__title">{{ 'layout.chat.title' | translate }}</span>
      </div>
      <button
        *ngIf="sidebarUnfoldable"
        type="button"
        class="team-nav-icon-collapsed align-self-center mb-2"
        (click)="exitChatNav()"
        [title]="'layout.chat.backToApps' | translate"
        [attr.aria-label]="'layout.chat.backToApps' | translate"
      >
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <a
        class="team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start overflow-hidden text-nowrap custom-action-btn hover-effect team-sidebar-action"
        [ngClass]="{'px-3 rounded-pill w-100': !sidebarUnfoldable, 'justify-content-center px-0 rounded-circle w-auto': sidebarUnfoldable}"
        routerLink="/team/{{ chatRouteTeamCode }}/chats"
        [queryParams]="{ new: 'dm' }"
        [title]="'layout.chat.startChat' | translate"
      >
        <span class="team-nav-session__inner min-w-0 w-100" [class.justify-content-center]="sidebarUnfoldable">
          <svg cIcon name="cilPlus" class="team-nav-session__icon" size="lg"></svg>
          <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text">{{ 'layout.chat.startChat' | translate }}</span>
        </span>
      </a>
      <div class="team-nav-label" *ngIf="!sidebarUnfoldable && visibleChatConversations.length > 0">{{ 'layout.chat.title' | translate }}</div>
      <a
        *ngFor="let conv of visibleChatConversations; trackBy: trackByConversationKey"
        class="team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start custom-action-btn hover-effect team-sidebar-action min-w-0 ima-unread-anchor"
        [ngClass]="{'justify-content-center px-0 rounded-circle w-auto': sidebarUnfoldable, 'px-3 rounded-pill w-100': !sidebarUnfoldable}"
        [class.team-sidebar-action--ghost]="!isChatConversationActive(conv)"
        [class.team-nav-row-active]="isChatConversationActive(conv)"
        routerLink="/team/{{ chatRouteTeamCode }}/chats/{{ conv.conversation_key }}"
        [attr.title]="conv.name"
      >
        <span class="team-nav-session__inner w-100 min-w-0">
          <svg
            cIcon
            [name]="conv.type === 'dm' ? 'cilUser' : 'cilChatBubble'"
            class="team-nav-session__icon"
            size="lg"
          ></svg>
          <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text text-truncate">{{ conv.name }}</span>
        </span>
        <span class="ima-unread-dot" *ngIf="isChatConversationUnread(conv)" [attr.aria-label]="'layout.chat.unreadMessage' | translate"></span>
      </a>
      <div class="team-chat-nav__empty" *ngIf="!sidebarUnfoldable && visibleChatConversations.length === 0">
        {{ 'layout.chat.noConversations' | translate }}
      </div>
    </nav>

    <nav
      *ngIf="!chatNavMode"
      class="team-imaginus-nav"
      [class.team-imaginus-nav--collapsed]="sidebarUnfoldable"
      [attr.aria-label]="'layout.chat.historyAria' | translate"
    >
      <div class="team-nav-label" *ngIf="!sidebarUnfoldable && displayImaginusList.length > 0">{{ 'layout.chat.recent' | translate }}</div>
      <div
        *ngFor="let s of displayImaginusList"
        class="team-nav-session team-nav-session--row w-100"
        [class.team-nav-session--has-menu]="showSessionMenuDropdown"
        [class.is-pinned]="teamImaginusNav.isPinned(unifiedPinKey, sessionNavKey(s))"
        (touchstart)="onSessionRowTouchStart(s, $event)"
        (touchend)="onSessionRowTouchEnd($event)"
        (touchmove)="onSessionRowTouchMove($event)"
        (touchcancel)="onSessionRowTouchEnd($event)"
      >
        <a
          class="team-nav-pill text-decoration-none border-0 team-nav-session__link btn btn-transparent d-flex align-items-center text-start custom-action-btn hover-effect team-sidebar-action min-w-0"
          [ngClass]="{'justify-content-center px-0 rounded-circle w-auto': sidebarUnfoldable, 'px-3 rounded-pill w-100': !sidebarUnfoldable}"
          [class.team-sidebar-action--ghost]="!isSessionQueryActive(s)"
          [class.team-nav-row-active]="isSessionQueryActive(s)"
          routerLink="/home"
          [queryParams]="sessionQueryParams(s)"
          [attr.title]="sessionLabel(s.name)"
          (click)="onSessionLinkClick($event, s)"
        >
          <span class="team-nav-session__inner w-100 min-w-0">
            <svg
              cIcon
              [name]="teamImaginusNav.isPinned(unifiedPinKey, sessionNavKey(s)) ? 'cilPin' : 'cilChatBubble'"
              class="team-nav-session__icon"
              size="lg"
            ></svg>
            <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text text-truncate">{{ sessionLabel(s.name) }}</span>
          </span>
        </a>
        <div class="team-nav-session__tail" *ngIf="showSessionMenuDropdown">
          <c-dropdown
            [popperOptions]="sessionMenuPopperOptions"
            class="team-nav-dropdown"
          >
            <button
              type="button"
              cDropdownToggle
              class="team-nav-session__kebab"
              [attr.aria-label]="('layout.chat.menuPrefix' | translate) + ': ' + sessionLabel(s.name)"
            >
              <svg cIcon name="cilOptions" size="sm"></svg>
            </button>
            <ul cDropdownMenu class="team-nav-dropdown__menu">
              <li>
                <button
                  type="button"
                  cDropdownItem
                  class="team-nav-dropdown__item d-flex align-items-center gap-2 w-100 text-start"
                  (click)="onSessionMenuPin(s, $event)"
                >
                  <svg cIcon name="cilPin" class="team-nav-item-icon flex-shrink-0" size="sm"></svg>
                  <span>{{ teamImaginusNav.isPinned(unifiedPinKey, sessionNavKey(s)) ? ('layout.chat.unpin' | translate) : ('layout.chat.pin' | translate) }}</span>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  cDropdownItem
                  class="team-nav-dropdown__item d-flex align-items-center gap-2 w-100 text-start"
                  (click)="onSessionMenuRename(s, $event)"
                >
                  <svg cIcon name="cilPencil" class="text-body-secondary flex-shrink-0" size="sm"></svg>
                  <span>{{ 'layout.chat.rename' | translate }}</span>
                </button>
              </li>
              <li><hr class="dropdown-divider my-1" /></li>
              <li>
                <button
                  type="button"
                  cDropdownItem
                  class="team-nav-dropdown__item d-flex align-items-center gap-2 w-100 text-start text-danger"
                  (click)="onSessionMenuDelete(s, $event)"
                >
                  <svg cIcon name="cilTrash" class="flex-shrink-0" size="sm"></svg>
                  <span>{{ 'layout.chat.delete' | translate }}</span>
                </button>
              </li>
            </ul>
          </c-dropdown>
        </div>
      </div>
    </nav>
    </div>
  </ng-scrollbar>

  <div
    *ngIf="!sidebarUnfoldable"
    class="team-sidebar-footer px-3"
  >
    <div class="team-sidebar-footer__search imaginus-sidebar-search-wrap w-100">
      <app-imaginus-session-search placement="footer"></app-imaginus-session-search>
    </div>
    <div class="d-flex align-items-center gap-1 mt-2 mb-2 px-1">
      <a
        routerLink="/help"
        target="_blank"
        rel="noopener"
        class="team-sidebar-help-link text-decoration-none small text-muted"
      >
        {{ 'sidebar.user_guide' | translate }}
      </a>
      <app-help-article-link
        [articleId]="help.QUICK_START_RECOMMENDED_FLOW"
        [ariaLabel]="'sidebar.user_guide' | translate"
        [title]="'sidebar.user_guide' | translate"
      />
    </div>
  </div>
  </div>

</c-sidebar>

<div
  class="wrapper d-flex flex-column min-vh-100"
  [class.wrapper--sidebar-overlay-open]="sidebarVisible && isMobile"
>
  <div
    class="custom-mask"
    *ngIf="sidebarVisible && isMobile"
    (click)="hideSidebar()"
    aria-hidden="true"
  ></div>

  <app-default-header
    [cShadowOnScroll]="'sm'"
    class="d-print-none header header-sticky p-0 bg-transparent border-0"
    [class.mb-4]="!isContentBleed"
    [class.app-header--imaginus]="isContentBleed"
    position="sticky"
    sidebarId="sidebar1"
  />
  <div class="body flex-grow-1" [class.body--imaginus-bleed]="isContentBleed" [class.body--floating-offset]="!isContentBleed">
    <c-container
      breakpoint="lg"
      [ngClass]="isContentBleed ? 'px-0 imaginus-route-container' : 'px-2 px-sm-3 px-md-4 h-auto'"
    >
      <router-outlet />
    </c-container>
  </div>
</div>

<c-modal
  [visible]="appModalVisible"
  size="lg"
  alignment="center"
  class="app-launcher-modal"
  (visibleChange)="onAppModalVisibleChange($event)"
>
  <c-modal-header class="app-launcher-modal__header border-0 pb-0">
    <div class="w-100">
      <h4 class="modal-title fw-bold mb-1">{{ launcherText('title') }}</h4>
      <p class="text-body-secondary small mb-0">{{ launcherText('subtitle') }}</p>
    </div>
    <button cButtonClose (click)="appModalVisible = false"></button>
  </c-modal-header>

  <c-modal-body class="app-launcher-modal__body p-0">
    <div class="app-launcher-panel">
      <c-card class="border-0 shadow-sm mb-3 app-launcher-context-card">
        <c-card-body class="py-2 px-3">
          <div class="app-launcher-team-bar">
            <ng-container *ngIf="hasTeams">
              <label class="app-launcher-team-bar__label" for="teamAppsSelect">{{ launcherText('teamLabel') }}</label>
              <select
                *ngIf="teamAppsSelectMounted"
                id="teamAppsSelect"
                class="form-select form-select-sm app-launcher-team-bar__select"
                [(ngModel)]="selectedTeamCodeForApps"
                (ngModelChange)="onTeamAppsSelectionChange()"
              >
                <option *ngFor="let t of team_list; trackBy: trackTeamByCode" [value]="t.team_code">{{ t.team_name }}</option>
              </select>
              <button
                type="button"
                class="app-launcher-icon-btn"
                [disabled]="!selectedTeamCodeForApps"
                (click)="openTeamSettingsFromLauncher()"
                [attr.aria-label]="launcherText('teamSettings')"
              >
                <svg cIcon name="cilSettings" size="sm"></svg>
              </button>
            </ng-container>
            <div class="app-launcher-team-bar__actions">
              <button type="button" class="app-launcher-action-btn" (click)="openCreateTeamModal()">
                <svg cIcon name="cilPlus" size="sm"></svg>
                <span>{{ createTeamText('createNew') }}</span>
              </button>
              <button type="button" class="app-launcher-action-btn app-launcher-action-btn--secondary" (click)="openJoinTeamModal()">
                <svg cIcon name="cilGroup" size="sm"></svg>
                <span>{{ launcherText('joinTeam') }}</span>
              </button>
            </div>
          </div>
        </c-card-body>
      </c-card>

      <div *ngIf="showInlineJoinTeam" class="app-launcher-create-team">
        <label cLabel for="inlineJoinTeamInput" class="app-launcher-create-team__label">{{ launcherText('joinTeamCodeLabel') }}</label>
        <div class="app-launcher-create-team__row">
          <input
            cFormControl
            id="inlineJoinTeamInput"
            type="text"
            class="app-launcher-create-team__input"
            [(ngModel)]="joinTeamCode"
            [placeholder]="launcherText('joinTeamCodePlaceholder')"
            (keyup.enter)="submitJoinTeam()"
          />
          <button cButton color="secondary" variant="ghost" size="sm" (click)="closeTeamFormPanels()">{{ 'common.cancel' | translate }}</button>
          <button cButton color="primary" size="sm" class="text-white" [disabled]="!joinTeamCode.trim() || isApplyingJoinTeam" (click)="submitJoinTeam()">
            <c-spinner *ngIf="isApplyingJoinTeam" size="sm" class="me-1"></c-spinner>
            {{ launcherText('joinTeamSubmit') }}
          </button>
        </div>
      </div>

      <div *ngIf="showInlineCreateTeam" class="app-launcher-create-team">
        <label cLabel for="inlineTeamNameInput" class="app-launcher-create-team__label">{{ launcherText('newTeamName') }}</label>
        <div class="app-launcher-create-team__row">
          <input
            cFormControl
            id="inlineTeamNameInput"
            type="text"
            class="app-launcher-create-team__input"
            [(ngModel)]="newTeamName"
            [placeholder]="launcherText('teamNamePlaceholder')"
            (keyup.enter)="submitCreateTeam()"
          />
          <button cButton color="secondary" variant="ghost" size="sm" (click)="closeCreateTeamModal()">{{ 'common.cancel' | translate }}</button>
          <button cButton color="primary" size="sm" class="text-white" [disabled]="!newTeamName.trim() || isCreatingTeam" (click)="submitCreateTeam()">
            <c-spinner *ngIf="isCreatingTeam" size="sm" class="me-1"></c-spinner>
            {{ createTeamText('submit') }}
          </button>
        </div>
      </div>

      <ng-template #launcherAppGroup let-app let-favSection="favSection">
        <div class="app-launcher-group">
          <div class="app-launcher-group__head">
            <span class="app-launcher-group__icon">
              <svg cIcon [name]="app.icon" size="lg"></svg>
            </span>
            <div class="min-w-0">
              <div class="app-launcher-group__title">{{ app.name }}</div>
              <div class="app-launcher-group__desc">{{ app.description }}</div>
            </div>
          </div>
          <div class="app-link-list">
            <div *ngFor="let child of app.children" class="app-link-row">
              <button type="button" class="app-link-row__main" (click)="navigateToLink(child.url)">
                <span class="app-link-row__label">{{ child.name }}</span>
                <svg cIcon name="cilArrowRight" size="sm" class="app-link-row__chevron"></svg>
              </button>
              <button
                type="button"
                class="app-link-row__pin"
                [class.app-link-row__pin--active]="isFavoriteUrl(resolveAppUrl(child.url))"
                (click)="onToggleFavoriteClick($event, child, favSection, app.icon)"
                [attr.aria-label]="isFavoriteUrl(resolveAppUrl(child.url)) ? launcherText('unpin') : launcherText('pinToSidebar')"
                [attr.aria-pressed]="isFavoriteUrl(resolveAppUrl(child.url))"
              >
                <svg cIcon name="cilStar" size="sm"></svg>
              </button>
            </div>
            <div *ngIf="!app.children?.length" class="app-link-row">
              <button type="button" class="app-link-row__main" (click)="navigateToLink(app.url)">
                <span class="app-link-row__label">{{ launcherText('enterApp') }}</span>
                <svg cIcon name="cilArrowRight" size="sm" class="app-link-row__chevron"></svg>
              </button>
            </div>
          </div>
        </div>
      </ng-template>

      <section class="app-launcher-section">
        <div *ngIf="hasPendingTeams" class="app-launcher-pending-teams mb-3">
          <div class="app-launcher-section__head mb-2">
            <div class="min-w-0">
              <h6 class="app-launcher-section__title mb-0">{{ launcherText('pendingTeamsSection') }}</h6>
              <p class="app-launcher-section__hint mb-0">{{ launcherText('pendingTeamsHint') }}</p>
            </div>
          </div>
          <div class="app-launcher-pending-teams__list">
            <div *ngFor="let pt of pending_team_list" class="app-launcher-pending-team">
              <div class="min-w-0">
                <div class="app-launcher-pending-team__name">{{ pt.team_name }}</div>
                <div class="app-launcher-pending-team__meta">{{ pt.team_code }}</div>
              </div>
              <span class="badge rounded-pill text-bg-warning text-dark">{{ launcherText('pendingReview') }}</span>
            </div>
          </div>
        </div>

        <div
          *ngIf="!hasTeams && !hasPendingTeams && !personalAppList.length"
          class="app-launcher-empty-state"
        >
          <svg cIcon name="cilGroup" size="xl" class="app-launcher-empty-state__icon"></svg>
          <p class="app-launcher-empty-state__title mb-1">{{ launcherText('noTeams') }}</p>
          <p class="app-launcher-empty-state__hint mb-0">{{ launcherText('noTeamsHint') }}</p>
        </div>

        <p *ngIf="hasTeams && selectedTeamCodeForApps && teamAppsLoadedForCode !== selectedTeamCodeForApps" class="app-launcher-empty">{{ launcherText('loadingTeamApps') }}</p>
        <p *ngIf="hasTeams && selectedTeamCodeForApps && teamAppsLoadedForCode === selectedTeamCodeForApps && teamAppList.length === 0 && !personalAppList.length" class="app-launcher-empty">{{ launcherText('noTeamApps') }}</p>
        <p *ngIf="hasTeams && selectedTeamCodeForApps && teamAppsLoadedForCode === selectedTeamCodeForApps && teamAppList.length === 0 && personalAppList.length" class="app-launcher-empty mb-3">{{ launcherText('noTeamApps') }}</p>

        <ng-container *ngIf="hasTeams && selectedTeamCodeForApps && teamAppsLoadedForCode === selectedTeamCodeForApps">
          <ng-container *ngFor="let app of teamAppList">
            <ng-container
              *ngTemplateOutlet="launcherAppGroup; context: { $implicit: app, favSection: 'team' }"
            ></ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngFor="let app of personalAppList">
          <ng-container
            *ngTemplateOutlet="launcherAppGroup; context: { $implicit: app, favSection: 'personal' }"
          ></ng-container>
        </ng-container>
      </section>
    </div>
  </c-modal-body>
</c-modal>

<c-modal
  [visible]="sessionActionSheetOpen"
  (visibleChange)="onSessionActionSheetVisible($event)"
  alignment="center"
  class="session-action-sheet"
>
  <c-modal-header class="border-0 pb-0">
    <h5 class="modal-title fw-bold text-truncate w-100 mb-0" [attr.title]="sessionActionTarget?.name">
      {{ sessionActionTarget ? sessionLabel(sessionActionTarget.name) : ('layout.chat.defaultName' | translate) }}
    </h5>
  </c-modal-header>
  <c-modal-body class="pt-2 px-0 pb-3">
    <div class="d-flex flex-column gap-0" *ngIf="sessionActionTarget as t">
      <button
        type="button"
        class="btn btn-link text-start rounded-0 py-3 px-3 d-flex align-items-center gap-2 text-decoration-none border-bottom border-light session-action-sheet__btn"
        (click)="onSessionActionSheetPin(t)"
      >
        <svg cIcon name="cilPin" class="session-action-sheet__item-icon" size="sm"></svg>
        <span>{{ sessionActionTarget ? (teamImaginusNav.isPinned(unifiedPinKey, sessionNavKey(sessionActionTarget)) ? ('layout.chat.unpin' | translate) : ('layout.chat.pin' | translate)) : ('layout.chat.pin' | translate) }}</span>
      </button>
      <button
        type="button"
        class="btn btn-link text-start rounded-0 py-3 px-3 d-flex align-items-center gap-2 text-decoration-none border-bottom border-light session-action-sheet__btn"
        (click)="onSessionActionSheetRename(t)"
      >
        <svg cIcon name="cilPencil" class="session-action-sheet__item-icon" size="sm"></svg>
        <span>{{ 'layout.chat.rename' | translate }}</span>
      </button>
      <button
        type="button"
        class="btn btn-link text-start rounded-0 py-3 px-3 d-flex align-items-center gap-2 text-decoration-none text-danger session-action-sheet__btn"
        (click)="onSessionActionSheetDelete(t)"
      >
        <svg cIcon name="cilTrash" size="sm"></svg>
        <span>{{ 'layout.chat.delete' | translate }}</span>
      </button>
    </div>
  </c-modal-body>
</c-modal>

<div class="create-team-toast" *ngIf="createTeamToast" role="status" aria-live="polite">
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path d="M5 13l4 4L19 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <span>{{ createTeamToast }}</span>
</div>
